'use client';

import React, { useState, useEffect } from 'react';
import * as CookieConsent from 'vanilla-cookieconsent';

const CookieConfigButton = () => {
    const [showConfig, setShowConfig] = useState(false);


    useEffect(() => {
        const cookieConsentData = CookieConsent.getCookie();
        if (cookieConsentData) {
            setShowConfig(true);
        }
    }, []);


    return (
        <div id={'cookieConfigB'} className={`cookie-container ${showConfig ? 'show' : ''}`}>
            <button type="button" className={"cookie-button"} onClick={CookieConsent.showPreferences}>
                Configurar cookies
            </button>
        </div>
    );
};

export default CookieConfigButton;